import React from "react";
import { Button } from "@/components/ui/button";
import { formatDate } from "@/lib/api";
import RecordInspector, { useRecordInspector } from "@/components/app/RecordInspector";
import ProjectKpiCenter from "@/components/app/ProjectKpiCenter";
import { ChartBar, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, EmptyHint, useFetchList } from "./_shared";

export default function MPRPanel({ project }) {
  const inspector = useRecordInspector();
  const { items, loading, err } = useFetchList(`/projects/${project.id}/mpr/snapshots`, [project.id]);
  return (
    <div data-testid={`panel-mpr-${project.id}`}>
      <PanelHeader icon={ChartBar} title="Monthly Progress Reports" subtitle="MPR snapshots · for client reporting"
        action={<ProjectKpiCenter project={project} trigger={<Button size="sm" variant="outline">Open MPR center <ArrowRight size={11} className="ml-1" /></Button>} />} />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {err && <div className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5 text-[11px] text-amber-800">{err}</div>}
      {!loading && !err && items.length === 0 && <EmptyHint message="No MPR snapshots taken yet. Open the MPR center to create one." />}
      {items.length > 0 && (
        <ul className="space-y-1.5">
          {items.slice(0, 12).map((s) => (
            <li key={s.id}
                onClick={() => inspector.open(s, { title: `MPR · ${s.period || s.month || ""}`, subtitle: `${s.progress_pct ?? 0}% complete` })}
                data-testid={`mpr-row-${s.id}`}
                className="flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-sm cursor-pointer hover:bg-slate-50">
              <span className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500 w-24">{s.period || s.month || "—"}</span>
              <span className="min-w-0 flex-1 truncate text-slate-700">Progress {s.progress_pct ?? 0}% · Budget {s.budget_used_pct ?? 0}%</span>
              <span className="font-mono-alt text-[10px] text-slate-500">{formatDate(s.created_at)}</span>
            </li>
          ))}
        </ul>
      )}
      <RecordInspector {...inspector.props} />
    </div>
  );
}
